<template>
  <el-card class="box-card full-screen recharge-apply">
    <div ref="pageHead" class="table-page-head">
      <el-form :inline="true" :model="queryForm">
        <el-form-item :label="$t('checkStatus')">
          <el-select
            v-model="queryForm.status"
            :placeholder="$t('all')"
            size="small"
          >
            <el-option :label="$t('all')" value=""></el-option>
            <el-option :label="$t('new')" value="0"></el-option>
            <el-option :label="$t('inProgress')" value="1"></el-option>
            <el-option :label="$t('closed')" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="getList"
            :loading="isLoading"
            ><i class="el-icon-search"></i> {{ $t("query") }}</el-button
          >
        </el-form-item>
      </el-form>

      <el-row class="table-btns" type="flex" justify="space-between">
        <a
          @click="downloadEXCEL()"
          type="text"
          size="mini"
          style="cursor:pointer"
        >
          <i class="el-icon-download"></i> {{ $t("downloadEXCEL") }}
        </a>
        <el-button
          type="text"
          icon="el-icon-edit"
          @click="adjustLimit()"
          size="mini"
          class="text-btn"
          >{{ $t("adjustLimit") }}</el-button
        >
      </el-row>
    </div>
    <div
      class="data-table"
      :style="{
        top: queryTableHeight,
        height: `calc(100% - ${queryTableHeight} - 70px)`
      }"
    >
      <el-table
        :data="tableData.records"
        v-loading="isLoading"
        element-loading-background="rgba(255,255,255,0.4)"
        size="mini"
        height="100%"
      >
        <el-table-column
          prop="id"
          :label="$t('ID')"
          min-width="50"
        ></el-table-column>
        <el-table-column
          prop="customerId"
          :label="$t('customerID')"
          min-width="100"
        ></el-table-column>
        <el-table-column
          prop="montantTotal"
          :label="$t('amount')"
          min-width="160"
          align="center"
        >
          <template slot-scope="scope"
            ><span class="franc">₣</span
            >{{ Number(scope.row.montantTotal).formatMoney(0) }}</template
          >
        </el-table-column>

        <el-table-column prop="status" :label="$t('status')" min-width="130">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0" class="text-danger">{{
              $t("new")
            }}</span>
            <span v-if="scope.row.status == 1" class="text-warning">{{
              $t("inProgress")
            }}</span>
            <span v-if="scope.row.status == 2" class="text-primary">{{
              $t("closed")
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="typeAlert"
          :label="$t('dealType')"
          min-width="180"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.typeAlert == 0" class="text-success">{{
              $t("transaction")
            }}</span>
            <span v-if="scope.row.typeAlert == 1" class="text-danger">{{
              $t("wanted")
            }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="startTime"
          :label="$t('startTime')"
          min-width="160"
        >
          <template slot-scope="scope">{{
            scope.row.startTime
              ? $manba(scope.row.startTime).format("ymdhms")
              : ""
          }}</template>
        </el-table-column>
        <el-table-column prop="endTime" :label="$t('endTime')" min-width="160">
          <template slot-scope="scope">{{
            scope.row.endTime ? $manba(scope.row.endTime).format("ymdhms") : ""
          }}</template>
        </el-table-column>

        <el-table-column
          prop="orgInfoId"
          :label="$t('orgId')"
          min-width="150"
        ></el-table-column>

        <el-table-column
          prop="createTime"
          :label="$t('creationTime')"
          min-width="160"
        >
          <template slot-scope="scope">{{
            scope.row.createTime
              ? $manba(scope.row.createTime).format("ymdhms")
              : ""
          }}</template>
        </el-table-column>

        <el-table-column fixed="right" :label="$t('extend')" width="120">
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="openCheck(scope.row)"
              type="primary"
              >{{ $t("check") }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      background
      layout="total,sizes,prev,pager,next,jumper"
      :total="tableData.total || 0"
      :page-sizes="[20, 30, 50, 100, 200]"
      :page-size="pageSize"
      :current-page="currentPage"
      @size-change="setPageSzie"
      @current-change="setCurrentChange"
      @prev-click="setCurrentChange"
      @next-click="setCurrentChange"
    />

    <el-drawer
      :title="$t(applyTitle)"
      :visible.sync="isCheckApply"
      :direction="'rtl'"
      :modal="false"
      :destroy-on-close="true"
      :wrapperClosable="false"
      :size="700"
    >
      <el-form :model="checkForm" :rules="rules" ref="checkForm">
        <el-divider content-position="left">{{ $t("applyInfo") }}</el-divider>
        <el-form-item :label="$t('ID')" prop="id">
          <el-input size="medium" v-model="checkForm.id" disabled></el-input>
        </el-form-item>
        <el-divider content-position="left">{{ $t("checkInfo") }}</el-divider>
        <el-form-item :label="$t('checkStatus')" prop="status">
          <el-radio v-model="checkForm.status" :label="0" border>{{
            $t("new")
          }}</el-radio>
          <el-radio v-model="checkForm.status" :label="1" border>{{
            $t("inProgress")
          }}</el-radio>
          <el-radio v-model="checkForm.status" :label="2" border>{{
            $t("closed")
          }}</el-radio>
        </el-form-item>
        <div class="bottom-button">
          <el-button
            size="medium"
            type="primary"
            :loading="isLoading"
            @click="onSubmitCheckResult('checkForm')"
            >{{ $t("submit") }}</el-button
          >
        </div>
      </el-form>
    </el-drawer>

    <!-- Adjust transaction limit drawer-->
    <el-drawer
      :title="$t('adjustLimit')"
      :visible.sync="adjustLimitDrawer"
      :direction="'rtl'"
      :modal="false"
      :destroy-on-close="true"
      :wrapperClosable="false"
      :size="700"
    >
      <el-form
        :model="updateForm"
        :rules="adjustLimitRules"
        ref="updateForm"
        label-position="top"
      >
        <el-form-item
          :label="$t('currentAmountLimit')"
          prop="weeklyTransactionLimit"
        >
          <el-input size="medium" v-model="weeklyTransactionLimit" disabled>
            <template slot="prepend"
              ><i class="iconfont iconruishifalang"></i
            ></template>
          </el-input>
        </el-form-item>
        <el-form-item
          :label="$t('newAmountLimit')"
          prop="weeklyTransactionLimit2"
        >
          <el-input size="medium" v-model="updateForm.weeklyTransactionLimit2">
            <template slot="prepend"
              ><i class="iconfont iconruishifalang"></i
            ></template>
          </el-input>
        </el-form-item>
        <el-form-item class="bottom-button">
          <el-button
            size="medium"
            type="primary"
            @click="updateSubmit('updateForm')"
            :loading="isLoading"
          >
            {{ $t("submit") }}
          </el-button>
        </el-form-item>
      </el-form>
    </el-drawer>
  </el-card>
</template>

<script>
import alertTransaction from "@/api/alertTransaction";
import qs from "qs";
import transactionLimit from "@/api/transactionLimit.js";

export default {
  name: "transactionAlert",
  data() {
    return {
      isLoading: false,
      //table高度，动态设置
      queryTableHeight: String,
      tableData: {},
      //分页器默认参数
      pageSize: 20,
      currentPage: 1,
      /**查询条件  [new Date("2021-08-01"), new Date("2021-10-01")] */
      queryForm: { size: Number, current: Number },

      isCheckApply: false,
      applyTitle: "check",
      checkForm: {},

      adjustLimitDrawer: false,
      //applyTitle2: "edit",

      weeklyTransactionLimit: "",
      idTransaction: "",
      updateForm: {
        id: "",
        weeklyTransactionLimit2: ""
      },

      transactionLimitList: []
    };
  },
  computed: {
    downloadUrl() {
      let _this = this;
      let param = JSON.parse(JSON.stringify(_this.queryForm));

      delete param.size;
      delete param.current;

      return (
        alertTransaction.alertTransactionDetailedExport +
        "?" +
        qs.stringify(param)
      );
    },
    rules() {
      return {
        status: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur"
          }
        ]
      };
    },
    adjustLimitRules() {
      return {
        weeklyTransactionLimit2: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur"
          }
        ]
      };
    },
    loginInfo() {
      return this.$store.state.globalParameter.loginInfo;
    }
  },
  watch: {},
  methods: {
    downloadEXCEL() {
      let download = document.createElement("a");
      download.href = this.downloadUrl;
      download.download = "";
      download.click();
    },
    openCheck(row) {
      this.isCheckApply = true;
      this.checkForm = {
        id: row.id,
        status: row.status
      };
    },

    adjustLimit() {
      this.adjustLimitDrawer = true;

      this.updateForm = {
        id: this.idTransaction,
        weeklyTransactionLimit2: "" // for user to enter new limit
      };
    },

    getTransactionLimit() {
      let _this = this;
      transactionLimit.getList({
        success: res => {
          //_this.transactionLimitList = res.data;
          _this.transactionLimitList = res.data;
          _this.idTransaction = res.data[0].id;
          _this.weeklyTransactionLimit = res.data[0].weeklyTransactionLimit;
        }
      });
    },

    getList() {
      let _this = this;
      _this.isLoading = true;
      let params = JSON.parse(JSON.stringify(_this.queryForm));

      alertTransaction.getPage({
        param: {
          current: _this.currentPage,
          size: _this.pageSize,
          ...params
        },
        success: res => {
          _this.isLoading = false;
          _this.tableData = res.data || {};
        }
      });
    },

    updateSubmit(formName) {
      let _this = this;
      _this.isLoading = true;
      _this.$refs[formName].validate(valid => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(_this.updateForm));
          transactionLimit.update({
            param: params,
            success: res => {
              if (res.code == 200) {
                _this.$message({
                  type: "success",
                  message: _this.$t("operateSuccessfully")
                });
                _this.getTransactionLimit();
                _this.adjustLimitDrawer = false;
              } else {
                _this.$message({ type: "warning", message: _this.$t(res.msg) });
              }
              _this.isLoading = false;
            }
          });
        }
      });
    },

    setPageSzie(val) {
      this.pageSize = val;
      this.getList();
    },
    setCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    }
  },
  mounted() {
    let queryTableHeight = this.$refs.pageHead.offsetHeight + 15;
    this.queryTableHeight = queryTableHeight + "px";
    this.getList();
    this.getTransactionLimit();
  }
};
</script>

<style></style>
